import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as routing from '../../../routing';
import ProfileIcon from '../../icons/profile-icon';
import styles from './login-button.module.scss';

const LoginButton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Link
      href={routing.accountLogin(window.location.href)}
      prefetch={false}
      className={styles.container}
      title={t('account.login')}
    >
      <ProfileIcon />
    </Link>
  );
};

export default LoginButton;
